export default "__VITE_ASSET__Aa88VnpN__"